export default __webpack_public_path__ + "static/affiliateBg-299c950c1ba789f63c974bedb4bc9f2f.png";